import { render, staticRenderFns } from "./NotificationsQueue.vue?vue&type=template&id=cb29a8ca"
import script from "./NotificationsQueue.vue?vue&type=script&lang=ts"
export * from "./NotificationsQueue.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsQueue.vue?vue&type=style&index=0&id=cb29a8ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports